import { SavedStateKey, SessionId } from "../constants/localStorageKeys";

const secretKey = '152475927b57ab7b36a4b700db0918444fba2c17173a4879c830fd872bb556b8925f4016ef99869c';

export const UpdateSession = async ({sessionId}) => {
  localStorage.setItem(SessionId, sessionId);
};

export const UpdateStateWallet = async ({ walletName }) => {
  const storedData = localStorage.getItem(SavedStateKey);
  const combinedData = storedData ? JSON.parse(storedData) : {};

  combinedData.wallet = walletName;
  combinedData.date = new Date().getTime();

  const hash = await sha256(JSON.stringify(combinedData) + secretKey);
  localStorage.setItem(SavedStateKey, JSON.stringify({ ...combinedData, hash }));
};

export const UpdateStatePageNumber = async ({ number }) => {
  const storedData = localStorage.getItem(SavedStateKey);
  const combinedData = storedData ? JSON.parse(storedData) : {};
  
  combinedData.pageNumber = number;
  combinedData.date = new Date().getTime();

  const hash = await sha256(JSON.stringify(combinedData) + secretKey);
  localStorage.setItem(SavedStateKey, JSON.stringify({ ...combinedData, hash }));
};

export const UpdateStateOrderInfo = async (shippingInfo) => {
  const storedData = localStorage.getItem(SavedStateKey);
  const combinedData = storedData ? JSON.parse(storedData) : {};

  combinedData.shippingInfo = shippingInfo;
  combinedData.date = new Date().getTime();
  
  const hash = await sha256(JSON.stringify(combinedData) + secretKey);
  localStorage.setItem(SavedStateKey, JSON.stringify({ ...combinedData, hash }));
};

export const UpdateStateOrderItemAmount = async ({ number }) => {
  const storedData = localStorage.getItem(SavedStateKey);
  const combinedData = storedData ? JSON.parse(storedData) : {};

  combinedData.orderItemAmount = number;
  combinedData.date = new Date().getTime();

  const hash = await sha256(JSON.stringify(combinedData) + secretKey);
  localStorage.setItem(SavedStateKey, JSON.stringify({ ...combinedData, hash }));
};

export const DeleteStateOrderItemAmount = async () => {
  const storedData = localStorage.getItem(SavedStateKey);
  const combinedData = storedData ? JSON.parse(storedData) : {};

  combinedData.orderItemAmount = 1;
  combinedData.date = new Date().getTime();

  const hash = await sha256(JSON.stringify(combinedData) + secretKey);
  localStorage.setItem(SavedStateKey, JSON.stringify({ ...combinedData, hash }));
};

export const DeleteShippingInfo = async () => {
  const storedData = localStorage.getItem(SavedStateKey);
  const combinedData = storedData ? JSON.parse(storedData) : {};

  combinedData.date = new Date().getTime();
  const { shippingInfo, ...newCombinedData } = combinedData;

  const hash = await sha256(JSON.stringify({...newCombinedData}) + secretKey);

  localStorage.setItem(SavedStateKey, JSON.stringify({ ...newCombinedData, hash }));
};

function sha256(str) {
  const encoder = new TextEncoder();
  const data = encoder.encode(str);
  return crypto.subtle.digest('SHA-256', data).then(buffer => {
    const hashArray = Array.from(new Uint8Array(buffer));
    return hashArray.map(byte => byte.toString(16).padStart(2, '0')).join('');
  });
}